import axios, { type AxiosError, type AxiosResponse } from 'axios';
import config from 'config';

export const client = axios.create({
  baseURL: config.API_SERVER,
  withCredentials: true,
  withXSRFToken: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
});

if (config.CF_ACCESS_CLIENT_ID && config.CF_ACCESS_CLIENT_SECRET) {
  client.interceptors.request.use(requestConfig => {
    requestConfig.headers['CF-Access-Client-Id'] = config.CF_ACCESS_CLIENT_ID;
    requestConfig.headers['CF-Access-Client-Secret'] = config.CF_ACCESS_CLIENT_SECRET;
    return requestConfig;
  });
}

let sessionRefreshPromise: Promise<unknown> | null = null;
let sessionInvalidationCallback: (() => void) | null = null;

export const setSessionInvalidationCallback = (callback: () => void): void => {
  sessionInvalidationCallback = callback;
};

client.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    const status = error.response?.status;
    const url: string = error.config?.url || '';
    if (status === 401 && !url.includes('/auth/session/')) {
      if (!sessionRefreshPromise) {
        sessionRefreshPromise = client
          .get('/auth/session/')
          .catch(() => null)
          .finally(() => {
            sessionRefreshPromise = null;
          });
      }
      const refreshResult = await sessionRefreshPromise!.catch(() => null);
      if (!refreshResult && sessionInvalidationCallback) {
        sessionInvalidationCallback();
      }
    }
    return Promise.reject(error);
  },
);
